import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
// Phase II · Wave D.1 · additive · initialises the Wave-D-scoped
// react-i18next instance (separate from the pre-existing M14
// `@/i18n/I18nContext`). The import side-effect calls .init() once.
import "@/i18n/wave_d1/config";
import App from "@/App";
// Wave X.B · Sentry init · graceful no-op if DSN missing.
import { initFrontendSentry } from "@/lib/sentryInit";
initFrontendSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
